module.exports = __webpack_public_path__ + "img/1fie-r-eat.141ecda5.jpg";